<template>
  <v-container fluid>
    <v-row  dense>
      <v-col cols="12">
        <!-- <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/> -->
        <DataTableMainServer :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"
        :Updatepagination="params" :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
        <ViewDetails :object="object" type="Proveedor" />
        <ReportDialog :dialog2="openDialog"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
// import DataTableMain from '@/components/tables/DataTableMain'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'
import ReportDialog from '@/components/dialog/ReportDialog'
export default {
  mixins: [Permission],
  data: () => ({
    openDialog: false,
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'empresa.departamentos.create-update' },
          { title: 'Reporte', icon: 'mdi-file-excel', color: 'blue-grey lighten-1', action: 'showDialogFechas', pagination: {}, code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'RFC', value: 'rfc', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: [
          // { title: 'Activar / Desactivar', icon: 'mdi-checkbox-blank-circle', color: 'grey darken-3', action: 'disableData', code: 'empresa.departamentos.up-down' }
          // { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-3', action: 'deleteData', code: 'empresa.departamentos.delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {}
  }),
  components: {
    // DataTableMain,
    DataTableMainServer,
    ViewDetails,
    ReportDialog
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'PUTDisableEnableObjectService', 'DELETEObjectService', 'POSTPagination']),
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN', 'SHOW_DIALOG_ALERT_MAIN', 'SHOW_DIALOG_REPORT']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true
      if (val) this.params = val
      else this.params = this.default
      this.ExecuteUrl('proveedor.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('proveedor.list-pagination')
      // this.pages = val
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    /* *==========*==========*==========*==========*==========*==========*==========*==========* */
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('proveedor.list-pagination')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Nuevo',
        body: {
          objectMain: { empresa_id: this.user.empresa_id },
          paramsDialog: {
            url: this.get_urls['proveedor.execute'],
            urloption: this.get_urls['proveedor.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Departamento`,
        body: {
          objectMain: item,
          url: this.get_urls['empresa.departamentos.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    updateData ({ item }) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Editar Departamento',
        body: {
          objectMain: item,
          paramsDialog: {
            form: this.get_DepartamentosForm,
            url: this.get_urls['empresa.departamentos.create-update'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    deleteData  ({ item }) {
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'delete',
        with: '40%',
        title: 'Eliminar Departamento',
        body: {
          objectMain: item,
          url: this.get_urls['empresa.departamentos.delete'],
          message: '¿Estás seguro de eliminar el registro?',
          description: 'No podras revertir el movimiento'
        },
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No, Cancelar'
      })
    },

    toUploadDoc (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Cargar Documentos',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['proveedor.execute'],
            urloption: this.get_urls['proveedor.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item
          }
        }
      })
    },
    toEdit (item) {
      const data = {
        rfc: item.item.rfc,
        nombre: item.item.nombre,
        es_linea_captura: item.item.datos_bancarios.es_linea_captura,
        cuenta_bancaria: item.item.datos_bancarios.cuenta,
        clabe_bancaria: item.item.datos_bancarios.clabe,
        numero_saf: item.item.datos_saf.numero,
        fExpedicionSaf: item.item.datos_saf.fecha_expedicion,
        fecha_vigencia: item.item.datos_saf.fecha_vigencia,
        banco: item.item.banco,
        banco_id: item.item.datos_bancarios.banco_id,
        estratificacion: this.capitalizeFirstLetter(item.item.estratificacion_mipymes),
        actividad_economica: item.item.actividad_enconomica,
        actividad_economica_id: item.item.actividad_economica_id,
        correo: item.item.contacto.correo,
        telefono: item.item.contacto.telefono,
        ext: item.item.contacto.ext,
        celular: item.item.contacto.celular,
        pagina: item.item.pagina_web,
        calle: item.item.domicilio_fiscal.calle,
        exterior: item.item.domicilio_fiscal.exterior,
        fraccionamiento: item.item.domicilio_fiscal.fraccionamiento,
        cp: item.item.domicilio_fiscal.cp,
        clave_municipio: item.item.domicilio_fiscal.clave_municipio,
        municipio: item.item.domicilio_fiscal.municipio,
        clave_entidad: item.item.domicilio_fiscal.clave_entidad,
        tipo: this.capitalizeFirstLetter(item.item.tipo),
        nombres: item.item.representante_legal.nombres,
        apellido_paterno: item.item.representante_legal.apellido_paterno,
        apellido_materno: item.item.representante_legal.apellido_materno,
        representante_rfc: item.item.representante_legal.rfc,
        representante_correo: item.item.representante_legal.contacto.correo,
        representante_telefono: item.item.representante_legal.contacto.telefono,
        tipo_acreditacion_id: item.item.representante_legal.tipo_acreditacion_id,
        persona_fisica_calle: item.item.representante_legal.domicilio_fiscal.calle,
        persona_fisica_num_exterior: item.item.representante_legal.domicilio_fiscal.exterior,
        persona_fisica_fraccionamiento: item.item.representante_legal.domicilio_fiscal.fraccionamiento,
        persona_fisica_cp: item.item.representante_legal.domicilio_fiscal.cp
      }
      this.item = item
      console.log(data)
      // codigo para ocultar elementos de la vista al momento de editar
      if (this.capitalizeFirstLetter(item.item.tipo) === 'Moral') {
        const fiellMain = item.body.status_finish.formulario.fields.find(field => field.nameid === 'tipo')
        if (fiellMain) {
          fiellMain.isHidden.map(field => {
            const fieldHidden = item.body.status_finish.formulario.fields.find(f => f.nameid === field)
            if (fieldHidden) fieldHidden.hidden = false
          })
        }
      } else {
        const fiellMain = item.body.status_finish.formulario.fields.find(field => field.nameid === 'tipo')
        if (fiellMain) {
          fiellMain.isHidden.map(field => {
            const fieldHidden = item.body.status_finish.formulario.fields.find(f => f.nameid === field)
            if (fieldHidden) fieldHidden.hidden = true
          })
        }
      }

      this.SHOW_DIALOG_MAIN({
        type: 'assign',
        form: 'process',
        with: '50%',
        title: 'Editar proveedor',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['proveedor.execute'],
            urloption: this.get_urls['proveedor.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data
          }
        }
      })
    },
    showDialogFechas (item) {
      this.SHOW_DIALOG_REPORT({
        tittle: 'Reporte de proveedores',
        urloption: this.get_urls['proveedor.get-reporte'],
        type: 'xlsx'
      })
    },
    capitalizeFirstLetter (str) {
      const capitalized = str.charAt(0).toUpperCase() + str.slice(1)
      return capitalized
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_dialogMain', 'get_objectPagination',
      'get_DepartamentosForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
